import React from 'react'
import { useSelector } from 'react-redux'

import SiteWrapper from '../components/sitewrapper'
import Layout from '../components/layout'
import Intro from '../components/intro'
import styles from '../component-styles/campaign-codes-generator-help.module.scss'
import Button from '../components/button'
import CampaignIntroContent from '../components/campaign-intro-content'
import TrackHelpContent from '../components/track-help-content'
import { SiteState } from '../store/site-reducer'

export default function CampaignCodesGeneratorHelp(): React.ReactElement {
  const { site }: { site: SiteState } = useSelector((s: any): any => s)

  const loading = !site || !site.selected
  const isAdobe = !!site?.selected?.adobe

  return (
    <SiteWrapper>
      <Layout width={1200}>
        <Intro title="Learn how to track your campaigns">
          <CampaignIntroContent>
            <p>Click on a topic below to start learning.</p>
          </CampaignIntroContent>
        </Intro>

        {!loading && <TrackHelpContent adobe={isAdobe} />}

        <Button to="/track/create-campaign-codes" className={styles.button}>
          Create campaign links
        </Button>
      </Layout>
    </SiteWrapper>
  )
}
